import { reduce } from "lodash";

export function normalizeFormField(fieldValue, normalizers = [], cb) {
  const normalizedValue = reduce(
    normalizers,
    (prevValue, normalizer) => normalizer(prevValue),
    fieldValue
  );
  if (cb) {
    cb(normalizedValue);
  }
  return normalizedValue;
}
